<template>
  <div class="lv-meta-links fds">
    <p class="desc mb-0">
      <icon glyph="related-object" aria-hidden="true" class="mr-2"></icon>
      {{totalCount}} record{{ totalCount === 1 ? '' : 's'}}
    </p>
    <p v-if="showCreateRelatedEntry" class="mb-0">
      <button @click="$emit('click-create-related-entry')" type="button" class="btn-link desc mb-0">
        Create Record
      </button>
    </p>
    <p v-if="showViewAll" class="mb-0">
      <button @click="$emit('click-view-all')" type="button" class="btn-link desc mb-0">
        View All
        <icon glyph="open-file" class="ml-2" tag="small" aria-hidden="true"></icon>
      </button>
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    totalCount: {
      type: Number,
      default: null
    },
    showViewAll: {
      type: Boolean,
      default: false
    },
    showCreateRelatedEntry: {
      type: Boolean,
      default: false
    },
    // "connected" text provides a contextual hint that you are viewing records related/connected to a 'parent' record, after having clicked "View All" from that parent record
    showConnectedText: {
      type: Boolean,
      default: false
    }
  },
});
</script>